import React from 'react'
import './QuestionText.scss'

const QuestionText = ({ children }) => {
  return (
    <div className='question-text'>{children}</div>
  )
}

export default QuestionText